let app = {

   init() {
      let articleContent = document.querySelector('.article-content')
      if (articleContent && articleContent.offsetHeight < 300) {
         articleContent.style.columnCount = 1
         articleContent.style.maxWidth = "500px"
         articleContent.style.marginLeft = "auto"
         articleContent.style.marginRight = "auto"
      }

   },
}

setTimeout(() => {
   app.init()
}, 0)
